import http from "@/http-common";
import {
  SACharakteristik,
  SADownloadAsset,
  SAFachinformation,
  SAFachinformationMessstelle,
  SAFreizeitnutzungen,
  SAHydrologie,
  SAKommerzielleNutzung,
  SASeeMischungVerhaeltnis,
  SASKommerziellerNutzungsTyp,
  SAStammdatenBase,
  SAStammdatenVerwaltungseinheiten
} from "./interfaces";

class SeenatlasService {
  constructor() {
    console.info("SeenatlasService initialized");
  }

  getSAStammdatenBase(see_nr: string) {
    return http.get<SAStammdatenBase>(
      `data/seenatlas_stammdaten_stammdaten?w=see_nr=mixed:${see_nr}`
    );
  }

  getSAVerwaltungseinheiten(seeId: number) {
    return http.get<Array<SAStammdatenVerwaltungseinheiten>>(
      `data/seenatlas_stammdaten_verwaltungseinheiten?w=see_id=${seeId}`
    );
  }

  getSAFreizeitnutzungen(seeId: number) {
    return http.get<Array<SAFreizeitnutzungen>>(
      `data/seenatlas_stammdaten_freizeitnutzungenbyid?w=see_id=${seeId}`
    );
  }

  getSAKommerziellenutzungTypes() {
    return http.get<Array<SASKommerziellerNutzungsTyp>>(
      `data?view=seenatlas_stammdaten_kommerznutzungen`
    );
  }

  getSASeeMischungVerhaeltnisse() {
    return http.get<Array<SASeeMischungVerhaeltnis>>(
      `data?view=seenatlas_stammdaten_seeerklmischungsverhaltenliste`
    );
  }

  getSAKommerzielleNutzungen(seeId: number) {
    return http.get<Array<SAKommerzielleNutzung>>(
      `data/seenatlas_stammdaten_kommerznutzungenbyid?w=see_id=${seeId}`
    );
  }

  getSAFachinformationen(see_nr: string) {
    return http.get<Array<SAFachinformation>>(
      `data/seenatlas_fachinformationen_fachinfos?w=see_nr=mixed:${see_nr}`
    );
  }

  getSAFachinformationMessstellen(see_nr: string) {
    return http.get<Array<SAFachinformationMessstelle>>(
      `data/seenatlas_fachinformationen_messstellenbyseeid?w=see_nr=mixed:${see_nr}`
    );
  }

  getSACharakteristik(id: string) {
    return http.get<Array<SACharakteristik>>(
      `data/seenatlas_allgemeineinformationen_textallgemeines?w=see_nr=mixed:${id}`
    );
  }

  getSAHydrologie(id: string) {
    return http.get<SAHydrologie>(
      `data/seenatlas_allgemeineinformationen_texthydrologie?w=see_nr=mixed:${id}`
    );
  }

  getSADownloadAsset(id: string) {
    return http.get<Array<SADownloadAsset>>(
      `data/seenatlas_download_downloads?w=see_nr=mixed:${id}`
    );
  }
}

export const seenatlasService = new SeenatlasService();
